import { Button, Col, Image, Row, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { storeredirectPath, storeReleasesEnumsValue } from '../../store/products/productsActions';

interface Props {
    image?: any;
    topButtton: any;
    mainHeading: any;
    subHeading: any;
    subHeading1: any;
    tagline: any;
    bottomButton: any;
    Link?: any
}

const CarouselItems = (props: Props) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [selectedtag, setSelectedTag] = useState(0)
    const handleClick1 = async (selectedOption: any) => {
        dispatch(storeReleasesEnumsValue(selectedOption));
        dispatch(storeredirectPath(true));
        history.push(`/releases`)

    };
    const _enum: any = {
        1: "New Releases",
        2: "FORTHCOMING",
        3: "REPRESSES",
        4: "BEST SELLER",
        5: "RSD SPECIALS",
    };
    useEffect(() => {
        if (props.topButtton === "New Releases") {
            setSelectedTag(1)
        } else if (props.topButtton === "FORTHCOMING") {
            setSelectedTag(2)
        } else if (props.topButtton === "REPRESSES") {
            setSelectedTag(3)
        } else if (props.topButtton === "BEST SELLER") {
            setSelectedTag(4)
        } else if (props.topButtton === "RSD SPECIALS") {
            setSelectedTag(5)
        }
    }, [props.topButtton])

    const handlelink = (link: any) => {
        window.open(link, '_sblank', 'noopener')
    }
    return (
      <div className="banner-container" data-aos="fade-out">
        <Row className='banner-row'>
          <Col className="left-content" sm={24} lg={12} xl={12}>
            <Image src={props?.image} preview={false} />
          </Col>
          <Col className="right-content" sm={24} lg={12} xl={12}>
            <Button
              className="rounded-btn top btn-small right-content-badge uppercase"
              shape="circle"
            >
              {props.topButtton}
            </Button>

            <Typography.Title level={3}>{props.mainHeading}</Typography.Title>
            <Typography.Title level={4}>{props.subHeading}</Typography.Title>
            <Typography.Title className='uppercase' level={5}>{props.subHeading1}</Typography.Title>
            <Typography.Text>{props.tagline}</Typography.Text>
            <Button
              className="rounded-btn with-hover"
              shape="circle"
              onClick={() => handlelink(props.Link)}
            >
              {props.bottomButton}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25.625"
                height="17.623"
                viewBox="0 0 25.625 17.623"
              >
                <g
                  id="Group_280"
                  data-name="Group 280"
                  transform="translate(6855.444 -343.358) rotate(180)"
                >
                  <path
                    id="Path_13"
                    data-name="Path 13"
                    d="M6838.983-343.712l-8.458-8.458,8.458-8.458"
                    transform="translate(0.001 0)"
                    fill="none"
                    stroke="#fff"
                    stroke-width="1"
                  />
                  <line
                    id="Line_7"
                    data-name="Line 7"
                    x2="24.5"
                    transform="translate(6830.944 -352.426)"
                    fill="none"
                    stroke="#fff"
                    stroke-width="1"
                  />
                </g>
              </svg>
            </Button>
          </Col>
        </Row>
      </div>
    );
}

export default CarouselItems;